import { FC } from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as InteractiveFingerIcon } from '../../../../../../../common/icon/interactive/interactive-finger.svg';
import { ReactComponent as InteractiveRingIcon } from '../../../../../../../common/icon/interactive/interactive-ring.svg';
import translation from '../../../../../../../languages';
import cn from '../../../../../../../utils/classnames';

type ContentPropsType = TranslationProps & {
    empty: boolean;
    amount: number;
};

const InteractiveMenuContent: FC<ContentPropsType> = ({ t, amount, empty }) => {
    const isActiveNavigationAbTest = useSelector(
        (state: RootState) => state.main.schoolClassification.isActiveNavigationAbTest
    );

    return (
        <div className='align-items-center d-flex flex-column justify-content-between header-interactive-btn'>
            <div
                aria-label='Interactive Icon - Image Holder'
                className={cn('img-holder d-flex align-items-start justify-content-center position-relative', {
                    empty
                })}
                data-amount={amount}
                role='img'
            >
                <InteractiveRingIcon className='ring-icon' />
                <InteractiveFingerIcon className='finger-icon' />
            </div>
            <div className='text-holder d-none d-lg-block text-center'>
                <div className={isActiveNavigationAbTest ? 'tsc-caption' : undefined}>
                    {t('header.interactive.title')}
                </div>
            </div>
        </div>
    );
};

const translate = translation('header');

export default translate(InteractiveMenuContent);
